// extracted by mini-css-extract-plugin
export default {"container":"Additions__container___MIjlH","actions":"Additions__actions___2RysD"};